import { CHALLENGE_DIRECTORY } from './';
const navLinks = [
  { id: 'r4', title: 'workouts', route: `/${CHALLENGE_DIRECTORY}/workouts` },
  { id: 'r5', title: 'leaderboard', route: `/${CHALLENGE_DIRECTORY}/leaderboards` },
  { id: 'r6', title: 'faq', route: `/${CHALLENGE_DIRECTORY}/faq` },
]

export { navLinks }
